import { useState, useEffect } from 'react';
/**
 * Custom hook for managing form state with edit mode
 * @param {string} initialValue - The initial value for the form
 * @returns {Object} Form state and handlers
 */
export const useFormState = (initialValue) => {
    const [showEdit, setShowEdit] = useState(false);
    const [formValue, setFormValue] = useState(initialValue);
    useEffect(() => {
        if (!showEdit) {
            setFormValue(initialValue);
        }
    }, [initialValue, showEdit]);
    const startEditing = (value) => {
        setShowEdit(true);
        setFormValue(value);
    };
    const cancelEditing = (resetValue) => {
        setShowEdit(false);
        setFormValue(resetValue);
    };
    const saveChanges = (onSave) => {
        setShowEdit(false);
        onSave(formValue);
    };
    return {
        showEdit,
        formValue,
        setFormValue,
        startEditing,
        cancelEditing,
        saveChanges,
    };
};
